export const messages = {
  en: {
    itemReleaseFinish: {
      title: 'Finished Release Orders',
      back: 'Back',
      refresh: 'Refresh',
      orderNo: 'Order No',
      releaseType: 'Release Type',
      applyUnit: 'Apply Unit',
      applicant: 'Applicant',
      idCard: 'ID Card',
      phone: 'Phone',
      passTime: 'Pass Time',
      items: 'Items',
      viewItems: 'View Items',
      status: 'Status',
      plateNo: 'Plate No',
      none: 'None',
      operation: 'Operation',
      detail: 'Detail',
      fetchError: 'Failed to fetch data'
    },
  },
  zh: {
    itemReleaseFinish: {
      title: '放行已办单',
      back: '返回',
      refresh: '刷新',
      orderNo: '单号',
      releaseType: '放行类型',
      applyUnit: '申请单位',
      applicant: '申请人',
      idCard: '身份证',
      phone: '手机号',
      passTime: '通行时间',
      items: '物品',
      viewItems: '查看物品',
      status: '状态',
      plateNo: '车牌号',
      none: '无',
      operation: '操作',
      detail: '详情',
      fetchError: '获取数据失败'
    },
  },
  'zh-TW': {
    itemReleaseFinish: {
      title: '放行已辦單',
      back: '返回',
      refresh: '刷新',
      orderNo: '單號',
      releaseType: '放行類型',
      applyUnit: '申請單位',
      applicant: '申請人',
      idCard: '身份證',
      phone: '手機號',
      passTime: '通行時間',
      items: '物品',
      viewItems: '查看物品',
      status: '狀態',
      plateNo: '車牌號',
      none: '無',
      operation: '操作',
      detail: '詳情',
      fetchError: '獲取數據失敗'
    },
  }
}
